export const INAVLID_CREDENTIALS = 'Invalid User Name or Password';
export const NOT_ABLE_TO_VALIDATE = 'Unable to validate credentials: ';
export const LOGOUT_SUCCESS = 'Logged out successfully'
export const LOGOUT_FAILURE = 'Failure logging out'
